<div class="flex-layout operational-dashboard">
  <div class="content-box">
    <insight-upcoming-orders class="on-dashboard"></insight-upcoming-orders>
  </div>

  <div class="flex-layout">
    <div class="content-box">
      <insight-cvd-dongle-info class="on-dashboard"></insight-cvd-dongle-info>
    </div>

    <div class="content-box">
      <insight-errors-by-ship-date class="on-dashboard"></insight-errors-by-ship-date>
    </div>

    <div class="content-box">
      <insight-errors-by-component class="on-dashboard"></insight-errors-by-component>
    </div>

    <div class="content-box">
      <insight-component-status class="on-dashboard"></insight-component-status>
    </div>

    <div class="content-box">
      <insight-upcoming-orders-with-missing-content class="on-dashboard"></insight-upcoming-orders-with-missing-content>
    </div>

    <div class="content-box">
      <insight-orders-by-status class="on-dashboard"></insight-orders-by-status>
    </div>
  </div>

  <!-- Trending titles doesn't appear to be used. Just hide it for now-->
  <!-- <div class="content-box">
    <insight-trending-titles></insight-trending-titles>
  </div> -->
</div>

